import { Component, OnInit, Input, type SimpleChanges, OnChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { faChevronDown, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { User, ServiceType, UserLoyaltyCode } from '@sabstravtech/obtservices/angular';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  Airlines,
  RailCompanies,
  HotelChains,
  CarCompanies,
  LoyaltyValue
} from '@sabstravtech/obtservices/base';
import moment from 'moment';

import { BaseComponent } from '../../core/components/base_components/base-componet';

@Component({
  selector: 'app-profile-information-loyalty',
  templateUrl: './profile-information-loyalty.component.html',
  styleUrls: ['./profile-information-loyalty.component.scss'],
  standalone: false
})
export class ProfileInformationLoyaltyComponent extends BaseComponent implements OnInit, OnChanges {
  tabSelected = 0;
  faChevronDown = faChevronDown;
  faCalendar = faCalendar;
  @Input() user: User;
  @Input() loyaltiesForm: FormGroup;
  @Input() isEditable: boolean;
  newLoyalty = {} as UserLoyaltyCode;
  serviceType = ServiceType;
  tabData: LoyaltyValue[] = Airlines;
  addNewLoyaltyForm: FormGroup;
  constructor(
    title: Title,
    translateService: TranslateService,
    private fb: FormBuilder
  ) {
    super(title, translateService);

    this.addNewLoyaltyForm = new FormGroup({
      type: new FormControl(ServiceType.Flight),
      carrier: new FormControl(''),
      code: new FormControl(''),
      expiryDate: new FormControl(null)
    });
  }

  get loyaltyCodes() {
    return this.loyaltiesForm.controls['loyaltyCodes'] as FormArray;
  }

  ngOnInit(): void {
    console.log(this.user);
    if (this.user && !this.loyaltyCodes.value.length) {
      this.setValue();
    }
    if (!this.isEditable) {
      this.loyaltiesForm.disable();
      this.addNewLoyaltyForm.disable();
    }

    if (this.user.loyaltyCodes?.length) {
      this.user.loyaltyCodes.forEach((loyalty: UserLoyaltyCode) => {
        this.addLoyalty(loyalty);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if loyalty is the first tab, sometimes it isn't loaded yet and needs updating
    if (changes['user'] && this.user && this.user.loyaltyCodes?.length) {
      this.user.loyaltyCodes.forEach((loyalty: UserLoyaltyCode) => {
        this.addLoyalty(loyalty);
      });
    }

    if (changes['loyaltyCodes'] && this.loyaltyCodes?.value?.length && this.user) {
      this.setValue();
    }
  }

  setValue() {
    this.loyaltiesForm.setValue({
      loyaltyCodes: []
    });

    if (this.user.loyaltyCodes?.length) {
      this.user.loyaltyCodes.forEach((loyalty: UserLoyaltyCode) => {
        this.addLoyalty(loyalty);
      });
    }
    this.showTabContent(this.tabSelected);
  }

  addLoyalty(loyalty: UserLoyaltyCode) {
    const loyaltiesForm = this.fb.group({
      type: [loyalty.type],
      carrier: [loyalty.carrier],
      code: [loyalty.code],
      expiryDate: [loyalty.expiryDate]
    });
    this.loyaltyCodes.push(loyaltiesForm);
  }

  deleteLoyalty(loyaltyId: number) {
    this.loyaltyCodes.removeAt(loyaltyId);
    this.loyaltiesForm.markAsDirty();
  }

  showTabContent(tabNumber: number) {
    this.tabSelected = tabNumber;
    switch (this.tabSelected) {
      case 0:
        this.tabData = Airlines;
        this.addNewLoyaltyForm.setValue({
          type: ServiceType.Flight,
          carrier: '',
          code: '',
          expiryDate: null
        });
        break;
      case 1:
        this.addNewLoyaltyForm.setValue({
          type: ServiceType.Rail,
          carrier: '',
          code: '',
          expiryDate: null
        });
        this.tabData = RailCompanies;
        break;
      case 2:
        this.tabData = HotelChains;
        this.addNewLoyaltyForm.setValue({
          type: ServiceType.Hotel,
          carrier: '',
          code: '',
          expiryDate: null
        });
        break;
      case 3:
        this.tabData = CarCompanies;
        this.addNewLoyaltyForm.setValue({
          type: ServiceType.Car,
          carrier: '',
          code: '',
          expiryDate: null
        });
        break;
      default:
        break;
    }
  }

  addNewLoyalty() {
    const expiryDate = this.addNewLoyaltyForm.get('expiryDate').value;
    if (expiryDate) {
      expiryDate.month -= 1;
    }
    const loyaltiesForm = this.fb.group({
      type: [this.addNewLoyaltyForm.get('type').value],
      carrier: [this.addNewLoyaltyForm.get('carrier').value],
      code: [this.addNewLoyaltyForm.get('code').value],
      expiryDate: expiryDate ? String(moment.utc(expiryDate).valueOf()) : null
    });
    this.loyaltyCodes.push(loyaltiesForm);
    this.loyaltiesForm.markAsDirty();
    // set default value
    this.addNewLoyaltyForm.setValue({
      type: ServiceType.Flight,
      carrier: '',
      code: '',
      expiryDate: null
    });
    this.tabSelected = 0;
    this.tabData = Airlines;
  }
}
